// extracted by mini-css-extract-plugin
export var subtitle = "_b9-2";
export var title = "_b9-0";
export var titleNoWrap = "_b9-1";